export const modalContent: Record<
  string,
  {
    category?: string;
    badge?: string;
    intro: string;
    items: string[];
    stats?: { value: string; label: string }[];
    useCases?: string[];
  }
> = {
  /* ================= SOLUCIONES ================= */
  "data-security": {
    category: "Solución Empresarial",
    badge: "Data Security",
    intro:
      "Protegemos tus activos de información más críticos con soluciones integrales de Data Security diseñadas para entornos empresariales complejos.",
    items: [
      "Descubrimiento y clasificación de datos sensibles en reposo y en tránsito.",
      "Prevención de pérdida de datos (DLP) con políticas granulares y monitoreo en tiempo real.",
      "Cifrado de datos con AES-256 y gestión segura de claves (KMS).",
      "Protección de bases de datos con enmascaramiento y tokenización.",
      "Cumplimiento normativo: PCI DSS, GDPR y LGPD.",
      "Integración con SIEM para correlación de eventos y detección de anomalías.",
    ],
    stats: [
      { value: "AES-256", label: "Cifrado de datos" },
      { value: "100%", label: "Cobertura DLP" },
      { value: "24/7", label: "Monitoreo" },
    ],
    useCases: ["Banca y finanzas", "Salud", "Retail y e-commerce"],
  },
  "endpoint-security": {
    category: "Solución Empresarial",
    badge: "Endpoint Security",
    intro:
      "Blindamos cada endpoint de tu organización contra malware, ransomware y amenazas avanzadas con protección multicapa.",
    items: [
      "EDR/XDR avanzado con detección comportamental y respuesta automatizada.",
      "Protección contra ransomware con aislamiento automático.",
      "Control de aplicaciones y prevención de ejecución no autorizada.",
      "Gestión centralizada de políticas para todos los dispositivos.",
      "Análisis de vulnerabilidades con priorización inteligente.",
      "Integración con MDM/EMM y Active Directory.",
    ],
    stats: [
      { value: "EDR/XDR", label: "Detección y respuesta" },
      { value: "< 5 min", label: "Contención" },
      { value: "99.9%", label: "Malware bloqueado" },
    ],
    useCases: ["Fuerza laboral híbrida", "Puestos corporativos", "Servidores críticos"],
  },
  "cloud-security": {
    category: "Solución Empresarial",
    badge: "Cloud Security",
    intro:
      "Aseguramos tu infraestructura cloud con arquitecturas Zero Trust y monitoreo continuo de configuraciones y accesos.",
    items: [
      "Evaluación de seguridad de configuraciones (CSPM) en AWS, Azure y GCP.",
      "Detección de amenazas en cargas de trabajo cloud (CWPP).",
      "Seguridad de contenedores y Kubernetes con runtime protection.",
      "Gestión de identidades y accesos cloud (CIEM).",
      "Protección de datos con cifrado y controles de soberanía.",
      "Cumplimiento continuo con SOC 2, ISO 27017, CIS y NIST.",
    ],
    stats: [
      { value: "3 nubes", label: "AWS · Azure · GCP" },
      { value: "Zero Trust", label: "Arquitectura" },
      { value: "24/7", label: "CSPM continuo" },
    ],
    useCases: ["Migración a la nube", "Multi-nube", "Kubernetes y contenedores"],
  },
  "application-security": {
    category: "Solución Empresarial",
    badge: "App Security",
    intro:
      "Desarrollamos y mantenemos aplicaciones seguras con prácticas DevSecOps integradas desde el primer commit hasta producción.",
    items: [
      "SAST/DAST/SCA integrado en pipelines CI/CD.",
      "Análisis de seguridad de APIs REST y GraphQL.",
      "Revisiones manuales de código por expertos.",
      "Pruebas de penetración web y móvil con OWASP y PTES.",
      "Gestión de vulnerabilidades con seguimiento de SLA.",
      "Capacitación de desarrolladores en Secure Coding.",
    ],
    stats: [
      { value: "SAST/DAST", label: "Análisis continuo" },
      { value: "OWASP", label: "Metodología" },
      { value: "CI/CD", label: "Integración" },
    ],
    useCases: ["Aplicaciones web y móviles", "APIs y microservicios", "Banca digital"],
  },
  "networking-security": {
    category: "Solución Empresarial",
    badge: "Networking Security",
    intro:
      "Protegemos tu red corporativa con arquitecturas segmentadas, monitoreo avanzado y respuesta automática a intrusiones.",
    items: [
      "Arquitecturas de red segmentadas (Zero Trust Network Architecture).",
      "Next-Gen Firewall (NGFW) con inspección profunda de paquetes.",
      "Intrusion Detection/Prevention Systems (IDS/IPS).",
      "Acceso remoto con VPN empresarial y MFA.",
      "Monitoreo de tráfico con análisis comportamental.",
      "Auditoría de seguridad de red y revisión de configuraciones.",
    ],
    stats: [
      { value: "NGFW", label: "Firewall nueva gen" },
      { value: "IDS/IPS", label: "Detección intrusos" },
      { value: "Zero Trust", label: "Segmentación" },
    ],
    useCases: ["Sedes corporativas", "Acceso remoto seguro", "Data center"],
  },
  "network-security": {
    category: "Solución Empresarial",
    badge: "Networking Security",
    intro:
      "Protegemos tu red corporativa con arquitecturas segmentadas, monitoreo avanzado y respuesta automática a intrusiones.",
    items: [
      "Arquitecturas de red segmentadas (Zero Trust Network Architecture).",
      "Next-Gen Firewall (NGFW) con inspección profunda de paquetes.",
      "Intrusion Detection/Prevention Systems (IDS/IPS).",
      "Acceso remoto con VPN empresarial y MFA.",
      "Monitoreo de tráfico con análisis comportamental.",
      "Auditoría de seguridad de red y revisión de configuraciones.",
    ],
    stats: [
      { value: "NGFW", label: "Firewall nueva gen" },
      { value: "IDS/IPS", label: "Detección intrusos" },
      { value: "Zero Trust", label: "Segmentación" },
    ],
    useCases: ["Sedes corporativas", "Acceso remoto seguro", "Data center"],
  },
  "threat-intelligence": {
    category: "Solución Empresarial",
    badge: "Ciberinteligencia",
    intro:
      "Nuestra plataforma de ciberinteligencia con IA detecta, analiza y neutraliza amenazas antes de que impacten tu organización.",
    items: [
      "Threat Intelligence Feeds con IoCs actualizados en tiempo real.",
      "Análisis de dark web y mercados de credenciales robadas.",
      "Detección de phishing y brand abuse con takedown.",
      "Inteligencia sobre actores de amenazas (APT) y TTPs.",
      "Vulnerability Intelligence basada en explotabilidad real.",
      "Informes ejecutivos de threat landscape con mitigación.",
    ],
    stats: [
      { value: "Tiempo real", label: "Feeds de amenazas" },
      { value: "Dark web", label: "Monitoreo" },
      { value: "APT", label: "Análisis de actores" },
    ],
    useCases: ["Protección de marca", "Prevención de fraude", "Respuesta a incidentes"],
  },
  "ciberinteligencia": {
    category: "Solución Empresarial",
    badge: "Ciberinteligencia",
    intro:
      "Nuestra plataforma de ciberinteligencia con IA detecta, analiza y neutraliza amenazas antes de que impacten tu organización.",
    items: [
      "Threat Intelligence Feeds con IoCs actualizados en tiempo real.",
      "Análisis de dark web y mercados de credenciales robadas.",
      "Detección de phishing y brand abuse con takedown.",
      "Inteligencia sobre actores de amenazas (APT) y TTPs.",
      "Vulnerability Intelligence basada en explotabilidad real.",
      "Informes ejecutivos de threat landscape con mitigación.",
    ],
    stats: [
      { value: "Tiempo real", label: "Feeds de amenazas" },
      { value: "Dark web", label: "Monitoreo" },
      { value: "APT", label: "Análisis de actores" },
    ],
    useCases: ["Protección de marca", "Prevención de fraude", "Respuesta a incidentes"],
  },

  /* ================= SERVICIOS ================= */
  "cybersoc": {
    category: "Servicio Especializado",
    badge: "CyberSOC",
    intro:
      "Nuestros Centros de Operaciones de Seguridad (SOC) operan 24/7/365 con analistas certificados y tecnología de detección de última generación.",
    items: [
      "Monitoreo continuo con SIEM, EDR, NDR y ciberinteligencia.",
      "Analistas certificados OSCP, CEH, GCIH y GCIA en turnos 24/7.",
      "Detección en minutos y contención en menos de 1 hora.",
      "MDR, Threat Hunting, Incident Response y forense digital.",
      "Reportes ejecutivos mensuales con métricas de seguridad.",
      "SOCs multi-país con redundancia geográfica.",
    ],
    stats: [
      { value: "24/7/365", label: "Monitoreo" },
      { value: "< 5 min", label: "Detección" },
      { value: "+200", label: "Especialistas" },
    ],
    useCases: ["Infraestructura crítica", "Clientes enterprise", "Cobertura multi-país"],
  },
  "consultorias": {
    category: "Servicio Especializado",
    badge: "Consultoría",
    intro:
      "Ofrecemos consultorías especializadas en ciberseguridad para evaluar, diseñar e implementar programas de seguridad adaptados a tu organización.",
    items: [
      "Evaluación de madurez con NIST, ISO 27001 y CIS Controls.",
      "Diseño de arquitecturas Zero Trust, SASE y microsegmentación.",
      "Auditorías de seguridad, pentesting y gap analysis.",
      "Políticas, continuidad de negocio y respuesta a incidentes.",
      "Asesoría regulatoria y cumplimiento normativo.",
      "Consultoría CISO-as-a-Service.",
    ],
    stats: [
      { value: "ISO 27001", label: "Cumplimiento" },
      { value: "NIST", label: "Framework" },
      { value: "CISO", label: "As-a-Service" },
    ],
    useCases: ["Implementación de SGSI", "Gap analysis", "Gobierno de seguridad"],
  },
  "security-consulting": {
    category: "Servicio Especializado",
    badge: "Seguridad Ofensiva",
    intro:
      "Servicios técnicos avanzados de ethical hacking, pentesting y análisis forense para identificar vulnerabilidades antes que los atacantes.",
    items: [
      "Evaluación de Hardening de sistemas y aplicaciones.",
      "Ethical Hacking en cajeros automáticos.",
      "Penetration Test con OWASP, PTES y OSSTMM.",
      "Seguridad SCADA/OT para entornos industriales.",
      "Análisis Forense digital y Red Team.",
      "Threat Hunting y análisis de código fuente.",
    ],
    stats: [
      { value: "OSCP", label: "Equipo certificado" },
      { value: "OWASP", label: "Metodología" },
      { value: "Red Team", label: "Ejercicios reales" },
    ],
    useCases: ["Pentesting", "Ethical hacking", "Análisis forense"],
  },
  "ingenieria-productos": {
    category: "Servicio Especializado",
    badge: "Ingeniería",
    intro:
      "Desarrollamos soluciones tecnológicas de seguridad personalizadas para resolver desafíos específicos de nuestros clientes.",
    items: [
      "Plataformas de monitoreo adaptadas a infraestructuras críticas.",
      "Integración de herramientas vía APIs, SOAR y playbooks.",
      "Dashboards ejecutivos con KPIs en tiempo real.",
      "Herramientas de hardening y remediación automatizada.",
      "Data lakes y modelos de machine learning para detección.",
      "Prototipado rápido con DevSecOps.",
    ],
    stats: [
      { value: "A medida", label: "Desarrollo" },
      { value: "APIs/SOAR", label: "Integración" },
      { value: "DevSecOps", label: "Metodología" },
    ],
    useCases: ["Dashboards ejecutivos", "Automatización SOAR", "Modelos de ML"],
  },
  "secure-academy": {
    category: "Servicio Especializado",
    badge: "Secure Academy",
    intro:
      "Secure Academy es nuestro programa de formación continua en ciberseguridad, diseñado para profesionales y organizaciones que buscan excelencia.",
    items: [
      "Cursos certificados: Ethical Hacking, SOC, Cloud, Forense.",
      "Laboratorios prácticos con entornos reales de ataque/defensa.",
      "Instructores certificados con experiencia real.",
      "Programas corporativos a medida para equipos de TI.",
      "Preparación: OSCP, CEH, Security+, CISSP, AWS Security.",
      "Modalidades presencial, virtual en vivo y blended.",
    ],
    stats: [
      { value: "OSCP/CEH", label: "Certificaciones" },
      { value: "Laboratorios", label: "Entornos reales" },
      { value: "Presencial", label: "+ Virtual" },
    ],
    useCases: ["Formación corporativa", "Certificación profesional", "Ciberrangos"],
  },

  "course-ethical-hacking": {
    category: "Curso · Secure Academy",
    badge: "Ethical Hacking",
    intro:
      "Formación ofensiva 100% práctica para identificar, explotar y documentar vulnerabilidades como lo haría un atacante real, bajo un marco ético y legal.",
    items: [
      "Metodologías OWASP, PTES y OSSTMM aplicadas en laboratorio.",
      "Laboratorios con entornos reales de ataque y defensa.",
      "Explotación de vulnerabilidades en web, redes y sistemas.",
      "Post-explotación, escalada de privilegios y movimiento lateral.",
      "Redacción de informes técnicos y ejecutivos.",
      "Preparación para la certificación OSCP.",
    ],
    stats: [
      { value: "40 h", label: "Duración" },
      { value: "Avanzado", label: "Nivel" },
      { value: "OSCP", label: "Preparación" },
    ],
    useCases: ["Pentesters", "Red Team", "Analistas ofensivos"],
  },
  "course-soc-analyst": {
    category: "Curso · Secure Academy",
    badge: "SOC Analyst L1",
    intro:
      "Curso diseñado para formar analistas capaces de operar en un Centro de Operaciones de Seguridad, detectando y respondiendo a incidentes en tiempo real.",
    items: [
      "Operación de SIEM: correlación y triage de alertas.",
      "Metodología MITRE ATT&CK para clasificar amenazas.",
      "Análisis de phishing, malware y tráfico sospechoso.",
      "Playbooks de respuesta y contención de incidentes.",
      "Uso de EDR/XDR y threat intelligence.",
      "Informes y escalamiento según severidad.",
    ],
    stats: [
      { value: "32 h", label: "Duración" },
      { value: "Nivel 1", label: "Analista SOC" },
      { value: "SIEM", label: "Enfoque" },
    ],
    useCases: ["Analistas SOC", "Blue Team", "Mesa de ayuda TI"],
  },
  "course-cloud-security": {
    category: "Workshop · Secure Academy",
    badge: "Cloud Security",
    intro:
      "Workshop práctico para asegurar entornos cloud en AWS, Azure y Google Cloud con arquitecturas Zero Trust y controles alineados a estándares internacionales.",
    items: [
      "Arquitecturas Zero Trust en la nube.",
      "Gestión de identidades y accesos (IAM) y roles.",
      "Evaluación de postura (CSPM) y malas configuraciones.",
      "Seguridad de contenedores y Kubernetes.",
      "Cifrado de datos en reposo y en tránsito.",
      "Cumplimiento cloud: CIS, NIST y SOC 2.",
    ],
    stats: [
      { value: "24 h", label: "Duración" },
      { value: "Workshop", label: "Formato" },
      { value: "Multi-cloud", label: "Cobertura" },
    ],
    useCases: ["Migración a cloud", "Kubernetes", "Equipos DevSecOps"],
  },
  "course-secure-academy": {
    category: "Programa · Secure Academy",
    badge: "Formación Continua",
    intro:
      "Programa integral de formación continua en ciberseguridad con rutas de aprendizaje por rol y un ciberrango de práctica permanente para profesionales y organizaciones.",
    items: [
      "Rutas de aprendizaje por rol: SOC, ofensiva, cloud y forense.",
      "Ciberrango con entornos de ataque y defensa reales.",
      "Instructores certificados con experiencia en campo.",
      "Certificaciones reconocidas: OSCP, CEH, Security+, CISSP.",
      "Modalidades presencial, virtual en vivo y blended.",
      "Programas corporativos a medida para equipos de TI.",
    ],
    stats: [
      { value: "+500", label: "Alumnos formados" },
      { value: "Rutas", label: "Por rol" },
      { value: "Blended", label: "Modalidades" },
    ],
    useCases: ["Formación corporativa", "Certificación profesional", "Ciberrango"],
  },

  /* ================= INDUSTRIAS ================= */
  "banca": {
    category: "Solución por Industria",
    badge: "Banca y Finanzas",
    intro:
      "Protegemos a los principales bancos y entidades financieras del Perú y Latinoamérica con soluciones que cumplen regulaciones BCP, SBS y PCI DSS.",
    items: [
      "Cumplimiento BCP, SBS y PCI DSS 3.2.1.",
      "Protección de canales digitales, apps y APIs de pagos.",
      "Detección de fraude con machine learning.",
      "Seguridad de infraestructura crítica y alta disponibilidad.",
      "Red Team simulando ataques a entidades financieras.",
      "Casos de éxito: 3 de los 5 bancos más grandes del Perú.",
    ],
    stats: [
      { value: "PCI DSS", label: "Cumplimiento" },
      { value: "24/7", label: "Monitoreo" },
      { value: "3/5", label: "Bancos top Perú" },
    ],
    useCases: ["Banca online", "Apps móviles", "APIs de pagos"],
  },
  "telecom": {
    category: "Solución por Industria",
    badge: "Telecom y TIC",
    intro:
      "Blindamos la infraestructura de telecomunicaciones y redes 5G de operadores líderes en la región.",
    items: [
      "Seguridad de infraestructura crítica y centros de datos.",
      "Protección de redes 5G, core networks y billing.",
      "Cumplimiento con regulaciones OSIPTEL.",
      "Seguridad de IoT y dispositivos conectados.",
      "Análisis de portales de autogestión y atención al cliente.",
      "Monitoreo 24/7 con SOCs dedicados al sector telecom.",
    ],
    stats: [
      { value: "5G", label: "Core networks" },
      { value: "OSIPTEL", label: "Cumplimiento" },
      { value: "24/7", label: "SOC dedicado" },
    ],
    useCases: ["Redes 5G", "IoT conectado", "Portales de autogestión"],
  },
  "seguros": {
    category: "Solución por Industria",
    badge: "Seguros y AFP",
    intro:
      "Aseguramos la información sensible de compañías de seguros y fondos de pensiones con soluciones que protegen datos de clientes y activos financieros.",
    items: [
      "Cumplimiento con regulaciones SBS.",
      "Protección de bases de datos de asegurados.",
      "Seguridad de plataformas de cotización y siniestros.",
      "Auditoría de sistemas core de pólizas y reclamos.",
      "Prevención de fraude en reclamaciones.",
      "Continuidad de negocio con planes de recuperación.",
    ],
    stats: [
      { value: "SBS", label: "Cumplimiento" },
      { value: "AES-256", label: "Cifrado de datos" },
      { value: "Anti-fraude", label: "Machine learning" },
    ],
    useCases: ["Pólizas online", "Reclamos y siniestros", "Datos de asegurados"],
  },
  "mineria": {
    category: "Solución por Industria",
    badge: "Minería y Energía",
    intro:
      "Protegemos la infraestructura OT/IT de empresas mineras, energéticas y petroleras con especialización en sistemas industriales.",
    items: [
      "Seguridad de sistemas OT/ICS/SCADA.",
      "Protección de infraestructura crítica del sector extractivo.",
      "Cumplimiento con regulaciones ambientales y de seguridad.",
      "Monitoreo de sensores IoT y telemetría.",
      "Auditoría de ERP de operaciones mineras.",
      "Respuesta a incidentes en entornos industriales aislados.",
    ],
    stats: [
      { value: "OT/ICS", label: "Especialización" },
      { value: "SCADA", label: "Protección" },
      { value: "24/7", label: "Monitoreo OT" },
    ],
    useCases: ["Sistemas SCADA", "Telemetría e IoT", "Operaciones remotas"],
  },
  "gobierno": {
    category: "Solución por Industria",
    badge: "Gobierno",
    intro:
      "Apoyamos a entidades gubernamentales con soluciones de ciberseguridad que cumplen estándares internacionales y locales.",
    items: [
      "Cumplimiento con marcos gubernamentales y NIST.",
      "Protección de infraestructura crítica y servicios digitales.",
      "Auditoría de sistemas de información públicos.",
      "Capacitación para funcionarios públicos.",
      "SOC para monitoreo continuo de amenazas.",
      "Gobernanza de ciberseguridad y políticas institucionales.",
    ],
    stats: [
      { value: "NIST", label: "Framework" },
      { value: "SOC", label: "Monitoreo continuo" },
      { value: "Capacitación", label: "Funcionarios" },
    ],
    useCases: ["Servicios al ciudadano", "Infraestructura crítica", "Gobernanza de seguridad"],
  },
  "educacion": {
    category: "Solución por Industria",
    badge: "Educación",
    intro:
      "Protegemos la información académica, investigaciones y datos de estudiantes de instituciones educativas de todos los niveles.",
    items: [
      "Protección de datos de estudiantes y personal.",
      "Seguridad de plataformas e-learning y campus virtual.",
      "Cumplimiento en protección de datos de menores.",
      "Capacitación para comunidades estudiantiles y docentes.",
      "Auditoría de redes campus y bibliotecas.",
      "Programas con presupuestos adaptados.",
    ],
    stats: [
      { value: "Campus", label: "Redes y WiFi" },
      { value: "e-learning", label: "Plataformas" },
      { value: "Menores", label: "Protección de datos" },
    ],
    useCases: ["Campus virtual", "Gestión académica", "WiFi institucional"],
  },
  "salud": {
    category: "Solución por Industria",
    badge: "Salud",
    intro:
      "Protegemos datos clínicos e infraestructura de salud con soluciones que cumplen regulaciones sanitarias y de privacidad.",
    items: [
      "Cumplimiento en protección de datos de salud.",
      "Protección de historias clínicas electrónicas.",
      "Seguridad de dispositivos médicos conectados (IoMT).",
      "Auditoría de sistemas de laboratorio e imágenes.",
      "Continuidad de negocio para servicios críticos.",
      "Capacitación para personal médico y administrativo.",
    ],
    stats: [
      { value: "IoMT", label: "Dispositivos médicos" },
      { value: "Historias", label: "Clínicas electrónicas" },
      { value: "24/7", label: "Continuidad" },
    ],
    useCases: ["Historia clínica", "Imágenes y laboratorio", "IoMT y redes clínicas"],
  },
  "retail": {
    category: "Solución por Industria",
    badge: "Retail y E-commerce",
    intro:
      "Protegemos plataformas de e-commerce y datos de clientes en el sector retail con soluciones de seguridad integral.",
    items: [
      "Cumplimiento PCI DSS para pagos con tarjeta.",
      "Protección contra fraude y bots en venta online.",
      "Seguridad de datos de clientes y CRM.",
      "Monitoreo de dark web de credenciales robadas.",
      "Auditoría de apps móviles de compras.",
      "Protección de logística y cadena de suministro digital.",
    ],
    stats: [
      { value: "PCI DSS", label: "Pagos seguros" },
      { value: "Anti-bot", label: "Prevención fraude" },
      { value: "Dark web", label: "Monitoreo" },
    ],
    useCases: ["E-commerce", "Apps de compras", "Programas de fidelización"],
  },
  "manufactura": {
    category: "Solución por Industria",
    badge: "Manufactura",
    intro:
      "Blindamos los sistemas de producción y cadena de suministro de empresas manufactureras contra amenazas cibernéticas.",
    items: [
      "Seguridad de ERP, MES y SCADA.",
      "Protección de propiedad intelectual y secretos industriales.",
      "Segmentación de redes OT/IT.",
      "Monitoreo de la cadena de suministro digital.",
      "Auditoría de sistemas de control industrial (ICS).",
      "Planes de continuidad operativa.",
    ],
    stats: [
      { value: "OT/IT", label: "Segmentación" },
      { value: "MES/SCADA", label: "Protección" },
      { value: "IP", label: "Propiedad intelectual" },
    ],
    useCases: ["Plantas de producción", "Cadena de suministro", "Sistemas ICS"],
  },
  "transporte": {
    category: "Solución por Industria",
    badge: "Transporte y Logística",
    intro:
      "Protegemos sistemas de transporte, logística y flotas con soluciones adaptadas a entornos operativos dinámicos.",
    items: [
      "Protección de rastreo GPS y gestión de flotas.",
      "Seguridad de plataformas de booking y tracking.",
      "Auditoría de control de tráfico y señalización.",
      "Cumplimiento en aviación, marítimo y terrestre.",
      "Monitoreo de IoT en vehículos conectados.",
      "Respuesta a incidentes adaptada a logística.",
    ],
    stats: [
      { value: "GPS", label: "Flotas y rastreo" },
      { value: "IoT", label: "Vehículos conectados" },
      { value: "24/7", label: "Respuesta" },
    ],
    useCases: ["Rastreo de flotas", "Booking y tracking", "Control de tráfico"],
  },
  "otros": {
    category: "Solución por Industria",
    badge: "Multi-sector",
    intro:
      "Openlab Secure atiende una amplia variedad de industrias con soluciones de ciberseguridad adaptadas a las necesidades específicas de cada sector.",
    items: [
      "Retail y e-commerce: protección de venta online.",
      "Salud y farmacéutica: protección de datos de pacientes.",
      "Manufactura: seguridad de ERP, MES y cadena de suministro.",
      "Transporte y logística: rastreo y plataformas de gestión.",
      "Construcción e inmobiliario: BIM, IoT y datos de proyectos.",
      "Evaluación personalizada de tu industria.",
    ],
    stats: [
      { value: "Multi-sector", label: "Experiencia" },
      { value: "A medida", label: "Soluciones" },
      { value: "Global", label: "Presencia" },
    ],
    useCases: ["Construcción e inmobiliario", "Servicios profesionales", "Retail y salud"],
  },

  /* ================= DATACENTER ================= */
  "datacenter-infraestructura": {
    category: "Servicio de Datacenter",
    badge: "Infraestructura",
    intro:
      "Infraestructura de misión crítica con estándares Tier III+, diseñada para garantizar la máxima disponibilidad y continuidad operativa de tu negocio.",
    items: [
      "Diseño e implementación con estándares Tier III+ y Uptime Institute.",
      "Redundancia N+1 en energía, refrigeración y conectividad.",
      "UPS con bancos de baterías y generadores de respaldo.",
      "Refrigeración de precisión para equipos de alta densidad.",
      "Monitoreo ambiental 24/7 y detección temprana de incendios.",
      "Control de acceso biométrico y videovigilancia CCTV.",
    ],
    stats: [
      { value: "Tier III+", label: "Estándar" },
      { value: "N+1", label: "Redundancia" },
      { value: "24/7", label: "Monitoreo" },
    ],
    useCases: ["Centros de datos", "Colocation", "Misión crítica"],
  },
  "datacenter-cloud": {
    category: "Servicio de Datacenter",
    badge: "Cloud",
    intro:
      "Migración, gestión y optimización de entornos cloud híbridos y multi-nube con los principales proveedores globales.",
    items: [
      "Arquitectura y migración a AWS, Azure y Google Cloud.",
      "Gestión de entornos híbridos on-premise y cloud pública.",
      "Escalabilidad elástica y optimización de costos (FinOps).",
      "Landing zones seguras con gobernanza y compliance.",
      "Infraestructura como código (Terraform, CloudFormation).",
      "Monitoreo cloud-native unificado.",
    ],
    stats: [
      { value: "3 nubes", label: "AWS · Azure · GCP" },
      { value: "FinOps", label: "Optimización" },
      { value: "IaC", label: "Terraform" },
    ],
    useCases: ["Migración a cloud", "Híbrido on-premise", "Landing zones"],
  },
  "datacenter-seguridad": {
    category: "Servicio de Datacenter",
    badge: "Seguridad",
    intro:
      "Protección integral de infraestructura física y lógica con múltiples capas de seguridad para entornos empresariales.",
    items: [
      "Firewalls de nueva generación (NGFW) con IPS/IDS.",
      "Web Application Firewall (WAF) contra OWASP Top 10.",
      "Data Loss Prevention (DLP) con políticas granulares.",
      "Cifrado en reposo (AES-256) y en tránsito (TLS 1.3).",
      "Gestión de vulnerabilidades con remediación automatizada.",
      "Seguridad perimetral y Zero Trust Network Access (ZTNA).",
    ],
    stats: [
      { value: "NGFW/WAF", label: "Perímetro" },
      { value: "AES-256", label: "Cifrado" },
      { value: "ZTNA", label: "Zero Trust" },
    ],
    useCases: ["Perímetro y DMZ", "Protección de aplicaciones", "Fuga de información"],
  },
  "datacenter-redes": {
    category: "Servicio de Datacenter",
    badge: "Redes",
    intro:
      "Diseño e implementación de redes enterprise de alto rendimiento con tecnologías SD-WAN, MPLS y fibra óptica dedicada.",
    items: [
      "Arquitecturas escalables con segmentación L2/L3 y BGP/OSPF.",
      "SD-WAN para optimización de tráfico y resiliencia.",
      "Enlaces MPLS y fibra óptica dedicada con SLA.",
      "Balanceo de carga L4/L7.",
      "Calidad de Servicio (QoS) para tráfico crítico.",
      "Monitoreo con NetFlow, SNMP y análisis en tiempo real.",
    ],
    stats: [
      { value: "SD-WAN", label: "Tecnología" },
      { value: "MPLS", label: "Enlaces dedicados" },
      { value: "QoS", label: "Priorización" },
    ],
    useCases: ["Redes multi-sede", "Fibra dedicada", "Balanceo de carga"],
  },
  "datacenter-ciberseguridad": {
    category: "Servicio de Datacenter",
    badge: "CiberSeguridad",
    intro:
      "CyberSOC 24/7 con Threat Hunting, SIEM, SOAR y análisis forense digital para proteger tu infraestructura contra amenazas avanzadas.",
    items: [
      "Monitoreo 24/7/365 con SIEM y correlación avanzada.",
      "Threat Hunting proactivo con IoCs y TTPs.",
      "SOAR para automatización de respuesta.",
      "Análisis forense digital con cadena de custodia.",
      "Threat Intelligence en tiempo real y dark web.",
      "Equipo de +200 especialistas certificados.",
    ],
    stats: [
      { value: "24/7/365", label: "Monitoreo" },
      { value: "SOAR", label: "Automatización" },
      { value: "+200", label: "Especialistas" },
    ],
    useCases: ["Threat Hunting", "Respuesta a incidentes", "Análisis forense"],
  },
  "datacenter-gestionados": {
    category: "Servicio de Datacenter",
    badge: "Servicios Gestionados",
    intro:
      "Monitoreo y gestión proactiva de infraestructura 24/7/365 desde nuestro NOC y SOC con detección temprana y respuesta automatizada.",
    items: [
      "Monitoreo proactivo con escalamiento automático.",
      "Gestión de incidentes con ITIL.",
      "Administración remota de servidores, storage y redes.",
      "Reportes ejecutivos mensuales con KPIs y SLA.",
      "Gestión de cambios con ventanas programadas.",
      "Respuesta automatizada y reducción de MTTR.",
    ],
    stats: [
      { value: "24/7", label: "Monitoreo proactivo" },
      { value: "ITIL", label: "Procesos" },
      { value: "SLA", label: "Cumplimiento" },
    ],
    useCases: ["Gestión de infraestructura", "Gestión de cambios", "Reportes ejecutivos"],
  },
  "datacenter-bbdd": {
    category: "Servicio de Datacenter",
    badge: "Bases de Datos",
    intro:
      "Administración experta de bases de datos Oracle, SQL Server, PostgreSQL y MySQL con backup, réplica y alta disponibilidad.",
    items: [
      "Administración de Oracle, SQL Server, PostgreSQL y MongoDB.",
      "Alta disponibilidad con clustering y failover automático.",
      "Backup y recuperación con RPO/RTO garantizados.",
      "Monitoreo de rendimiento y tuning proactivo.",
      "Réplicas off-site y backup cifrado.",
      "Migración entre plataformas con integridad validada.",
    ],
    stats: [
      { value: "Oracle/SQL", label: "Plataformas" },
      { value: "HA", label: "Alta disponibilidad" },
      { value: "RPO/RTO", label: "Garantizados" },
    ],
    useCases: ["Alta disponibilidad", "Backup y resguardo", "Migración de BD"],
  },
  "datacenter-dr": {
    category: "Servicio de Datacenter",
    badge: "Continuidad",
    intro:
      "Planes de BCP/DRP con sitios alternos, replicación sincrónica/asincrónica y RTO/RPO medibles para garantizar la continuidad operativa.",
    items: [
      "BCP y DRP alineados a ISO 22301.",
      "Sitios alternos (cold, warm, hot site).",
      "Replicación sincrónica y asincrónica.",
      "Pruebas periódicas con medición de RTO/RPO.",
      "Automatización de failover y failback.",
      "Análisis de impacto al negocio (BIA).",
    ],
    stats: [
      { value: "ISO 22301", label: "Alineación" },
      { value: "RTO/RPO", label: "Medibles" },
      { value: "Sitios", label: "Cold · Warm · Hot" },
    ],
    useCases: ["Plan de continuidad", "Sitios alternos", "Pruebas de DRP"],
  },
  "datacenter-venta": {
    category: "Servicio de Datacenter",
    badge: "Venta y Renting",
    intro:
      "Venta y distribución de licenciamiento enterprise y hardware de datacenter de los principales fabricantes globales.",
    items: [
      "Licenciamiento Microsoft: Windows Server, SQL, Azure.",
      "Licenciamiento Oracle: Database y Middleware.",
      "Virtualización VMware vSphere, vSAN y NSX.",
      "Hardware HPE/Dell/Lenovo y storage NetApp/Pure.",
      "Modalidades: compra, leasing, renting y suscripción.",
      "Soluciones llave en mano con soporte incluido.",
    ],
    stats: [
      { value: "Microsoft", label: "Licenciamiento" },
      { value: "Oracle", label: "Licenciamiento" },
      { value: "Renting", label: "Modalidad" },
    ],
    useCases: ["Licenciamiento enterprise", "Hardware de datacenter", "Llave en mano"],
  },
  "datacenter-consultoria": {
    category: "Servicio de Datacenter",
    badge: "Consultoría de Proyectos",
    intro:
      "Servicios profesionales de consultoría IT con metodologías ágiles y PMI para proyectos de infraestructura de principio a fin.",
    items: [
      "Dirección de proyectos con PMI (PMBOK) y agile.",
      "Diseño de arquitecturas de infraestructura.",
      "Planificación con cronograma y matriz de riesgos.",
      "Ejecución controlada con seguimiento de hitos.",
      "Puesta en marcha y transferencia de conocimiento.",
      "PMO externalizada con KPIs y dashboards.",
    ],
    stats: [
      { value: "PMI", label: "Metodología" },
      { value: "Agile", label: "Scrum · Kanban" },
      { value: "PMO", label: "Externalizada" },
    ],
    useCases: ["Dirección de proyectos", "Arquitectura de infraestructura", "Oficina de proyectos"],
  },

  /* ================= CAPACIDADES INTERNAS ================= */
  "cs-cap-1": {
    category: "Capacidad CyberSOC",
    badge: "Detección 24/7",
    intro:
      "Monitoreo continuo de tu infraestructura con sensores distribuidos en múltiples capas de red, endpoint y cloud.",
    items: [
      "Monitoreo de red, endpoint y cloud.",
      "Correlación de eventos en tiempo real.",
      "Alertas y escalamiento automático.",
      "Cobertura 24/7/365.",
    ],
    stats: [
      { value: "99.97%", label: "Uptime SOC" },
      { value: "24/7/365", label: "Monitoreo" },
      { value: "Multi-capa", label: "Cobertura" },
    ],
    useCases: ["Infraestructura crítica", "Entornos híbridos", "Multi-sede"],
  },
  "cs-cap-2": {
    category: "Capacidad CyberSOC",
    badge: "Respuesta a Incidentes",
    intro:
      "Equipos de respuesta listos para actuar en menos de 5 minutos con protocolos establecidos y playbooks automatizados.",
    items: [
      "Playbooks de respuesta automatizados.",
      "Contención en minutos.",
      "Análisis y erradicación.",
      "Informe post-incidente.",
    ],
    stats: [
      { value: "< 5 min", label: "MTTR promedio" },
      { value: "24/7", label: "Equipo activo" },
      { value: "100%", label: "Trazabilidad" },
    ],
    useCases: ["Ransomware", "Phishing dirigido", "Compromiso de credenciales"],
  },
  "cs-cap-3": {
    category: "Capacidad CyberSOC",
    badge: "Threat Hunting",
    intro:
      "Búsqueda proactiva de amenazas avanzadas que evaden la detección tradicional con análisis de comportamiento y machine learning.",
    items: [
      "Hipótesis de caza y validación.",
      "Análisis comportamental y ML.",
      "Detección de amenazas persistentes.",
      "Correlación con ciberinteligencia.",
    ],
    stats: [
      { value: "+200", label: "IoC diarios" },
      { value: "Proactivo", label: "Enfoque" },
      { value: "APT", label: "Detección" },
    ],
    useCases: ["Amenazas avanzadas", "Movimiento lateral", "Escenarios evasivos"],
  },
  "cs-cap-4": {
    category: "Capacidad CyberSOC",
    badge: "Ciberinteligencia",
    intro:
      "Monitoreo de dark web, foros de hackers y fuentes de inteligencia para anticipar ataques dirigidos a tu industria.",
    items: [
      "Monitoreo de dark web y foros.",
      "Feeds OSINT globales.",
      "Indicadores de compromiso.",
      "Alertas por industria.",
    ],
    stats: [
      { value: "5 Países", label: "Fuentes OSINT" },
      { value: "Tiempo real", label: "Feeds" },
      { value: "Dark web", label: "Monitoreo" },
    ],
    useCases: ["Protección de marca", "Credenciales filtradas", "Inteligencia de mercado"],
  },
  "cs-cap-5": {
    category: "Capacidad CyberSOC",
    badge: "EDR / XDR",
    intro:
      "EDR/XDR avanzado con correlación de eventos, análisis forense remoto y contención automática de amenazas.",
    items: [
      "EDR/XDR con correlación de eventos.",
      "Análisis forense remoto.",
      "Contención automática de amenazas.",
      "Gestión centralizada de endpoints.",
    ],
    stats: [
      { value: "12K+", label: "Endpoints" },
      { value: "Automatizado", label: "Contención" },
      { value: "XDR", label: "Correlación" },
    ],
    useCases: ["Fuerza laboral distribuida", "Puestos corporativos", "Servidores críticos"],
  },
  "cs-cap-6": {
    category: "Capacidad CyberSOC",
    badge: "Cloud Security",
    intro:
      "Protección continua de cargas de trabajo en AWS, Azure y GCP con detección de configuraciones inseguras.",
    items: [
      "Cobertura AWS, Azure y GCP.",
      "Detección de malas configuraciones.",
      "Seguridad de contenedores.",
      "CIEM y cumplimiento.",
    ],
    stats: [
      { value: "Multi-Cloud", label: "Cobertura" },
      { value: "CSPM", label: "Postura" },
      { value: "24/7", label: "Monitoreo" },
    ],
    useCases: ["Migración a cloud", "Kubernetes", "Multi-nube"],
  },
  "co-cap-1": {
    category: "Capacidad de Consultoría",
    badge: "Consultoría de Seguridad",
    intro:
      "Asesoría especializada para fortalecer la postura de seguridad con metodologías probadas y mejores prácticas de la industria.",
    items: [
      "Evaluación integral del entorno.",
      "Definición de hoja de ruta.",
      "Mejores prácticas y frameworks.",
      "Acompañamiento continuo.",
    ],
    stats: [
      { value: "ISO 27001", label: "Certificación" },
      { value: "NIST", label: "Framework" },
      { value: "+15 años", label: "Experiencia" },
    ],
    useCases: ["Madurez de seguridad", "Alineación estratégica", "Gobierno de seguridad"],
  },
  "co-cap-2": {
    category: "Capacidad de Consultoría",
    badge: "Assessment Tecnológico",
    intro:
      "Diagnóstico exhaustivo de infraestructura, redes y seguridad con identificación de vulnerabilidades y recomendaciones priorizadas.",
    items: [
      "Diagnóstico de infraestructura y redes.",
      "Identificación de vulnerabilidades.",
      "Brechas de cumplimiento.",
      "Hoja de ruta priorizada.",
    ],
    stats: [
      { value: "200+", label: "Assessments" },
      { value: "Priorizado", label: "Por riesgo" },
      { value: "360°", label: "Alcance" },
    ],
    useCases: ["Diagnóstico previo a proyecto", "Auditoría técnica", "Toma de decisiones"],
  },
  "co-cap-3": {
    category: "Capacidad de Consultoría",
    badge: "Cumplimiento Normativo",
    intro:
      "Adecuación a marcos regulatorios como ISO 27001, PCI DSS, NIST y leyes de protección de datos personales.",
    items: [
      "Adecuación a ISO 27001, PCI DSS y NIST.",
      "Ley de protección de datos personales.",
      "Preparación de auditorías.",
      "Acompañamiento a la certificación.",
    ],
    stats: [
      { value: "15+", label: "Frameworks" },
      { value: "PCI DSS", label: "Cumplimiento" },
      { value: "Auditoría", label: "Acompañamiento" },
    ],
    useCases: ["Certificación ISO 27001", "Cumplimiento PCI", "Protección de datos"],
  },
  "co-cap-4": {
    category: "Capacidad de Consultoría",
    badge: "Gestión de Riesgos",
    intro:
      "Identificación, análisis y tratamiento de riesgos de seguridad de la información alineados a ISO 31000 e ISO 27005.",
    items: [
      "Identificación de activos y riesgos.",
      "Análisis cuantitativo y cualitativo.",
      "Tratamiento y controles.",
      "Monitoreo continuo.",
    ],
    stats: [
      { value: "500+", label: "Riesgos mitigados" },
      { value: "ISO 31000", label: "Metodología" },
      { value: "Cuantitativo", label: "Análisis" },
    ],
    useCases: ["Matriz de riesgos", "Comité de riesgos", "Continuidad de negocio"],
  },
  "co-cap-5": {
    category: "Capacidad de Consultoría",
    badge: "Continuidad de Negocio",
    intro:
      "Desarrollo de BCP y DRP con análisis de impacto (BIA), estrategias de recuperación y pruebas periódicas.",
    items: [
      "Análisis de impacto (BIA).",
      "Estrategias de recuperación.",
      "Planes BCP y DRP.",
      "Pruebas periódicas.",
    ],
    stats: [
      { value: "RTO < 4h", label: "Garantizado" },
      { value: "ISO 22301", label: "Alineación" },
      { value: "BIA", label: "Análisis" },
    ],
    useCases: ["Recuperación ante desastres", "Sitios de respaldo", "Resiliencia operativa"],
  },
  "co-cap-6": {
    category: "Capacidad de Consultoría",
    badge: "Implementación SGSI",
    intro:
      "Diseño e implantación de Sistemas de Gestión de Seguridad de la Información alineados a los objetivos estratégicos.",
    items: [
      "Políticas y procedimientos.",
      "Diseño de controles.",
      "Implementación por fases.",
      "Gestión y mejora continua.",
    ],
    stats: [
      { value: "50+", label: "SGSI implementados" },
      { value: "ISO 27001", label: "Estándar" },
      { value: "Por fases", label: "Implementación" },
    ],
    useCases: ["Certificación ISO 27001", "Gobierno de la información", "Auditorías internas"],
  },
  "sd-cap-1": {
    category: "Capacidad Service Desk",
    badge: "Mesa de Ayuda 24/7",
    intro:
      "Atención continua multinivel L1/L2/L3 con registro, clasificación y resolución de tickets en tiempo real.",
    items: [
      "Soporte multinivel L1/L2/L3.",
      "Registro y clasificación de tickets.",
      "Atención 24/7/365.",
      "Escalamiento inteligente.",
    ],
    stats: [
      { value: "99.9%", label: "SLA garantizado" },
      { value: "24/7", label: "Atención" },
      { value: "L1/L2/L3", label: "Niveles" },
    ],
    useCases: ["Soporte corporativo", "Usuarios remotos", "Operación crítica"],
  },
  "sd-cap-2": {
    category: "Capacidad Service Desk",
    badge: "Gestión de Incidentes",
    intro:
      "Proceso estructurado de detección, diagnóstico y resolución de incidentes con escalamiento automático según criticidad.",
    items: [
      "Detección y diagnóstico.",
      "Escalamiento automático.",
      "Resolución y cierre.",
      "Análisis de causa raíz.",
    ],
    stats: [
      { value: "< 15 min", label: "Tiempo respuesta" },
      { value: "ITIL", label: "Procesos" },
      { value: "Automático", label: "Escalamiento" },
    ],
    useCases: ["Caídas de servicio", "Incidentes críticos", "Continuidad operativa"],
  },
  "sd-cap-3": {
    category: "Capacidad Service Desk",
    badge: "Gestión de Cambios",
    intro:
      "Control de cambios ITIL con evaluación de riesgo, planes de rollback y ventanas de mantenimiento programadas.",
    items: [
      "Evaluación de riesgos.",
      "Planes de rollback.",
      "Ventanas de mantenimiento.",
      "Aprobación y seguimiento.",
    ],
    stats: [
      { value: "98%", label: "Cambios exitosos" },
      { value: "ITIL", label: "Metodología" },
      { value: "Rollback", label: "Planificado" },
    ],
    useCases: ["Actualizaciones críticas", "Despliegues", "Mantenimientos programados"],
  },
  "sd-cap-4": {
    category: "Capacidad Service Desk",
    badge: "Base de Conocimiento",
    intro:
      "Repositorio centralizado de soluciones, FAQs y procedimientos estándar para resolución rápida y autónoma.",
    items: [
      "Artículos y procedimientos.",
      "FAQs de autoservicio.",
      "Búsqueda inteligente.",
      "Actualización continua.",
    ],
    stats: [
      { value: "5000+", label: "Artículos KB" },
      { value: "Autoservicio", label: "Self-service" },
      { value: "Actualizada", label: "Continuamente" },
    ],
    useCases: ["Resolución autónoma", "Onboarding de usuarios", "Estandarización"],
  },
  "sd-cap-5": {
    category: "Capacidad Service Desk",
    badge: "Métricas y Reportes",
    intro:
      "Dashboards en tiempo real con KPIs de servicio, tendencias de tickets y satisfacción del usuario final.",
    items: [
      "Dashboards en tiempo real.",
      "KPIs de servicio y SLA.",
      "Tendencias de tickets.",
      "Encuestas de satisfacción.",
    ],
    stats: [
      { value: "4.8/5", label: "CSAT score" },
      { value: "Tiempo real", label: "Métricas" },
      { value: "Ejecutivo", label: "Reporte" },
    ],
    useCases: ["Mejora continua", "Reportes gerenciales", "Cumplimiento de SLA"],
  },
  "sd-cap-6": {
    category: "Capacidad Service Desk",
    badge: "Omnicanalidad",
    intro:
      "Soporte vía teléfono, email, chat en vivo y portal de autoservicio. Tus usuarios eligen cómo contactarte.",
    items: [
      "Teléfono y email.",
      "Chat en vivo.",
      "Portal de autoservicio.",
      "WhatsApp y móvil.",
    ],
    stats: [
      { value: "5 Canales", label: "Disponibles" },
      { value: "Omnicanal", label: "Experiencia" },
      { value: "24/7", label: "Cobertura" },
    ],
    useCases: ["Soporte a usuarios", "Escalamiento masivo", "Comunicación proactiva"],
  },

  /* ================= INFO / LEGAL ================= */
  "politica-cookies": {
    badge: "Política de Cookies",
    intro:
      "Openlab Secure utiliza cookies para mejorar tu experiencia de navegación y analizar el tráfico del sitio web de manera segura.",
    items: [
      "Cookies esenciales: Necesarias para el funcionamiento y la seguridad del sitio.",
      "Cookies de rendimiento: Nos ayudan a entender cómo interactúas con el sitio.",
      "Cookies funcionales: Permiten recordar tus preferencias.",
      "Cookies de marketing: Muestran contenido relevante sobre nuestros servicios.",
      "Puedes modificar tus preferencias desde la configuración de tu navegador.",
    ],
  },
  "politica-privacidad": {
    badge: "Política de Privacidad",
    intro:
      "En Openlab Secure protegemos tu información personal con los más altos estándares de seguridad y cifrado de extremo a extremo.",
    items: [
      "Recopilamos solo los datos necesarios para brindarte nuestros servicios.",
      "Tu información se almacena con cifrado AES-256 y protocolos avanzados.",
      "No compartimos tus datos con terceros sin tu consentimiento.",
      "Puedes ejercer tus derechos de acceso, rectificación, cancelación y oposición.",
      "Conservamos tus datos solo el tiempo necesario para los fines establecidos.",
      "Consultas: privacidad@openlabsecure.com",
    ],
  },
  "politica-videovigilancia": {
    badge: "Política de Videovigilancia",
    intro:
      "Nuestros sistemas de videovigilancia cumplen con la normativa vigente y respetan estrictamente tu privacidad.",
    items: [
      "Las cámaras están ubicadas en áreas comunes de nuestras instalaciones.",
      "Las grabaciones se almacenan de forma segura con acceso restringido.",
      "El período de retención es de 30 días, salvo requerimiento legal.",
      "Se han implementado señaléticas informativas en áreas vigiladas.",
      "Puedes solicitar acceso a grabaciones donde aparezcas identificable.",
    ],
  },
  "politica-sst": {
    badge: "Política de SST",
    intro:
      "Openlab Secure prioriza la seguridad y salud en el trabajo de todos sus colaboradores como parte de su cultura organizacional.",
    items: [
      "Contamos con un Sistema de Gestión de SST certificado.",
      "Identificamos, evaluamos y controlamos los riesgos laborales.",
      "Capacitamos constantemente a nuestro personal en prevención.",
      "Disponemos de protocolos de emergencia y brigadas de respuesta.",
    ],
  },
  "manual-derechos-arco": {
    badge: "Manual ARCO",
    intro:
      "El Manual de Derechos ARCO te guía en el ejercicio de tus derechos sobre datos personales de forma clara y sencilla.",
    items: [
      "ACCESO: Conoce qué datos tenemos registrados sobre ti.",
      "RECTIFICACIÓN: Corrige datos inexactos o desactualizados.",
      "CANCELACIÓN: Solicita la eliminación de tus datos.",
      "OPOSICIÓN: Opóngete al tratamiento para fines específicos.",
      "Plazo de respuesta: 20 días hábiles, prorrogables por 10.",
      "Ejercita tus derechos a través del formulario o a privacidad@openlabsecure.com",
    ],
  },
  "guia-osiptel": {
    badge: "Guía OSIPTEL",
    intro:
      "Guía paso a paso para la presentación de reclamos ante OSIPTEL relacionados con servicios de telecomunicaciones.",
    items: [
      "Paso 1: Registra tu reclamo en el Libro de Reclamaciones de la operadora.",
      "Paso 2: Espera hasta 20 días hábiles para la respuesta formal.",
      "Paso 3: Si no estás conforme, presenta una apelación ante la operadora.",
      "Paso 4: Presenta queja formal ante OSIPTEL si persiste el problema.",
      "OSIPTEL: www.osiptel.gob.pe | Línea: 0800-43-500 | L-V 8:30 - 17:30",
    ],
  },
  "tratamiento-datos": {
    badge: "Tratamiento de Datos",
    intro:
      "En Openlab Secure tratamos tus datos personales de manera lícita, leal, transparente y con los más altos estándares de seguridad.",
    items: [
      "Finalidad: gestión de clientes, prestación de servicios y cumplimiento legal.",
      "Base legal: contrato, consentimiento, interés legítimo u obligación legal.",
      "Transferencias: solo nacionales, previa comunicación y con garantías.",
      "Plazo de conservación: durante la relación comercial y plazo legal.",
      "Medidas: cifrado AES-256, control de acceso y auditorías trimestrales.",
      "Responsable: Av. Principal 123, Of. 401, Lima, Perú.",
    ],
  },
  "preferencias-cookies": {
    badge: "Preferencias de Cookies",
    intro:
      "Personaliza qué cookies deseas permitir durante tu navegación en nuestro sitio web de ciberseguridad.",
    items: [
      "Cookies esenciales: siempre activas para autenticación y seguridad.",
      "Cookies de análisis: mejoran el sitio entendiendo el comportamiento anónimo.",
      "Cookies de funcionalidad: recuerdan preferencias de idioma y personalización.",
      "Cookies de publicidad: entregan anuncios más relevantes.",
      "Puedes cambiar tus preferencias en cualquier momento.",
    ],
  },
  "nosotros": {
    badge: "Centro de Excelencia",
    intro:
      "Openlab Secure es una empresa líder en ciberseguridad con presencia en Perú, Chile, Colombia, Ecuador, México, EEUU y Europa, protegiendo activos digitales de organizaciones de clase mundial.",
    items: [
      "SOCs certificados y auditados externamente en múltiples países.",
      "Calificaciones de 4.5/5 en Perú y 4.3/5 en Colombia y Ecuador.",
      "Certificaciones: ISO 9001, ISO 27001, ISO 22301, ISO 37001 y PCI DSS.",
      "Más de 200 especialistas certificados en ciberseguridad.",
      "Alianzas con los principales fabricantes de seguridad global.",
      "Estatus Risk Driven validado por LRQA.",
    ],
  },
  "vision-mision": {
    badge: "Visión y Misión",
    intro: "Nuestra visión y misión guían cada decisión que tomamos para proteger el futuro digital de nuestros clientes.",
    items: [
      "VISIÓN: Ser el socio estratégico de ciberseguridad más confiable de Latinoamérica y Europa.",
      "MISIÓN: Proteger los activos digitales con tecnología de punta, talento y procesos robustos.",
      "VALORES: Integridad, excelencia, innovación, colaboración y orientación al cliente.",
      "COMPROMISO: Respuesta a incidentes en menos de 15 minutos para clientes premium.",
    ],
  },
  "hitos": {
    badge: "Hitos y Trayectoria",
    intro: "Trayectoria de crecimiento y reconocimientos que consolidan a Openlab Secure como líder en ciberseguridad regional.",
    items: [
      "Fundación de Openlab Secure en Lima, Perú.",
      "Apertura del primer SOC certificado ISO 27001 en el Perú.",
      "Expansión a Chile y Colombia con equipos locales.",
      "Certificación PCI DSS y plataforma de ciberinteligencia propia.",
      "Apertura de sedes en Ecuador y México. +100 clientes enterprise.",
      "Expansión a Europa y EEUU. Lanzamiento de Secure Academy.",
    ],
  },
  "reconocimientos": {
    badge: "Premios y Reconocimientos",
    intro:
      "Openlab Secure ha sido reconocida por organismos nacionales e internacionales por la excelencia de sus servicios de ciberseguridad.",
    items: [
      "Estatus Risk Driven LRQA: selecto ecosistema global.",
      "Calificación 4.5/5 Prime Defense en Perú.",
      "Top 10 CISO Choice Awards por nuestra ciberinteligencia con IA.",
      "Partner del Año - Palo Alto Networks.",
      "Partner del Año - CrowdStrike.",
      "Certificación Great Place to Work.",
    ],
  },
  "partners": {
    badge: "Ecosistema de Alianzas",
    intro:
      "Colaboramos con los principales fabricantes y proveedores de tecnología de seguridad global para ofrecer soluciones integrales de clase mundial.",
    items: [
      "Palo Alto Networks: Partner Gold en firewalls y SASE.",
      "CrowdStrike: Partner Elite en EDR, XDR y threat hunting.",
      "Microsoft: Security Specialization en Azure.",
      "SentinelOne: Partner Premier en seguridad endpoint.",
      "Splunk: Partner Premier en SIEM, SOAR y análisis.",
      "Fortinet: Partner Advanced en SD-WAN y seguridad OT.",
    ],
  },
  "canal-denuncias": {
    badge: "Reporte Confidencial",
    intro:
      "Nuestro Canal de Denuncias permite reportar de forma confidencial, anónima y segura cualquier conducta que contravenga nuestros valores y políticas.",
    items: [
      "Disponible 24/7 vía portal web, línea telefónica y correo dedicado.",
      "Garantía de anonimato cuando corresponda.",
      "Protección al denunciante: compromiso de no represalias.",
      "Atención por Comité de Ética con respuesta en 15 días hábiles.",
      "Áreas: fraude, corrupción, acoso, conflictos de interés y seguridad.",
      "Acceso: canaldedenuncias@openlabsecure.com | Línea: +51 1 234 5699",
    ],
  },
  "politicas-corporativas": {
    badge: "Gobernanza Corporativa",
    intro:
      "Nuestras políticas corporativas definen los estándares de conducta, ética y seguridad que rigen todas nuestras operaciones.",
    items: [
      "Código de Ética y Conducta.",
      "Política de Seguridad de la Información.",
      "Política de Gestión de Riesgos.",
      "Política de Cumplimiento Normativo.",
      "Política de Diversidad e Inclusión.",
      "Disponibles para colaboradores y partes interesadas.",
    ],
  },
  "trabaja-nosotros": {
    badge: "Carrera en Ciberseguridad",
    intro:
      "Únete al equipo de ciberseguridad más talentoso de Latinoamérica y Europa. Valoramos el crecimiento profesional y el bienestar de nuestros colaboradores.",
    items: [
      "Beneficios: seguro médico premium, bonos por certificaciones y trabajo híbrido.",
      "Cultura: aprendizaje continuo con laboratorios de pentesting.",
      "Crecimiento: planes de carrera con mentoría de expertos.",
      "Vacantes: Analistas SOC, Pentesters, Consultores cloud, Ingenieros de ventas.",
      "Prácticas: Openlab Secure Academy para estudiantes.",
      "Postula a: talento@openlabsecure.com",
    ],
  },
};